/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Tapan Dabhi",
  logo_name: "TapanDabhi",
  nickname: "dabhitapan",
  subTitle:
    "I am a seasoned full-stack developer with expertise in crafting innovative solutions for web and mobile applications. Proficient in React, Angular, React Native, Node.js, and more. I have a proven track record in delivering end-to-end solutions across various industries.",
  resumeLink:
    "https://drive.google.com/file/d/1BbFVsfepgAa-0u7DmgcY7yhLQih77gNE/view?usp=sharing",
  portfolio_repository: "https://github.com/dabhitapan/Portfolio",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/dabhitapan",
  linkedin: "https://linkedin.com/in/tapan-dabhi",
  gmail: "tapandabhi99@gmail.com",
  gitlab: "https://gitlab.com/dabhitapan",
  facebook: "https://www.facebook.com/tapan.dabhi.7/",
  twitter: "https://twitter.com/dabhitapan",
  instagram: "https://www.instagram.com/wo_log_im_tony/",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front-end using React, Angular, and Vue",
        "⚡ Developing cross-platform mobile applications using React Native, Flutter, and Android",
        "⚡ Creating application backends in Node.js, PHP (Laravel), Java (Spring Boot), and Python",
        "⚡ Database management with MySQL, PostgreSQL, and NoSQL databases",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "Jquery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            backgroundColor: "#fff",
            color: "#0765A8",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            backgroundColor: "#ffffff",
            color: "#3178C6",
          },
        },
        {
          skillName: "React",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "React-Native",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#029FCE",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            color: "#764ABC",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "simple-icons:angular",
          style: {
            color: "#dd1b16",
          },
        },
        {
          skillName: "AngularJs",
          fontAwesomeClassname: "simple-icons:angularjs",
          style: {
            color: "#dd1b16",
          },
        },
        {
          skillName: "Vue.js",
          fontAwesomeClassname: "simple-icons:vuedotjs",
          style: {
            color: "#44BA84",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "RxJS",
          fontAwesomeClassname: "simple-icons:ngrx",
          style: {
            color: "#D81B5F",
          },
        },
        {
          skillName: "Webpack",
          fontAwesomeClassname: "simple-icons:webpack",
          style: {
            color: "#75B0CC",
          },
        },
        {
          skillName: "Vite",
          fontAwesomeClassname: "simple-icons:vite",
          style: {
            backgroundColor: "#BB36FE",
            color: "#FDD42B",
          },
        },
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            backgroundColor: "#356F9F",
            color: "#FEDC4F",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#8993be",
          },
        },
        {
          skillName: "Visual Basic",
          fontAwesomeClassname: "simple-icons:dot-net",
          style: {
            color: "#029FCE",
          },
        },
        {
          skillName: "Sprint-Boot",
          fontAwesomeClassname: "simple-icons:spring",
          style: {
            color: "#71B544",
          },
        },
        {
          skillName: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
          style: {
            color: "#FF2C1F",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#F2009B",
          },
        },
        {
          skillName: "Jest",
          fontAwesomeClassname: "simple-icons:jest",
          style: {
            color: "#4CC212",
          },
        },
        {
          skillName: "Cypress",
          fontAwesomeClassname: "simple-icons:cypress",
          style: {
            backgroundColor: "#000000",
            color: "#ffffff",
          },
        },
        {
          skillName: "Playwright",
          fontAwesomeClassname: "simple-icons:playwright",
          style: {
            color: "#47BA4B",
          },
        },
        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "Apache",
          fontAwesomeClassname: "simple-icons:apache",
          style: {
            color: "#CA1A22",
          },
        },
        {
          skillName: "NGINX",
          fontAwesomeClassname: "simple-icons:nginx",
          style: {
            color: "#009237",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "GitLab",
          fontAwesomeClassname: "simple-icons:gitlab",
          style: {
            color: "#E2432A",
          },
        },
        {
          skillName: "Google Play Store",
          fontAwesomeClassname: "simple-icons:googleplay",
          style: {
            color: "#3FA853",
          },
        },
        {
          skillName: "Apple AppStore",
          fontAwesomeClassname: "simple-icons:appstore",
          style: {
            backgroundColor: "#2EB1FC",
            color: "#ffffff",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms including AWS, GCP, Azure",
        "⚡ Hosting and maintaining websites on vm instances with integrated databases",
        "⚡ Setting up streaming jobs between databases and servers on GCP and AWS",
        "⚡ Utilizing Firebase for cloud-based services",
        "⚡ Containerization with Docker and orchestration with Kubernetes",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interfaces for mobile and web applications",
        "⚡ Creating intuitive flows for application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Zeplin",
          fontAwesomeClassname: "logos:zeplin",
          style: {
            color: "#FDBD39",
          },
        },
        {
          skillName: "Avocode",
          fontAwesomeClassname: "openmoji:avocado",
          style: {
            color: "#06976E",
          },
        },
      ],
    },
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable models for various deep learning and statistical use cases",
        "⚡ Hands-on experience with Computer Vision and NLP projects",
        "⚡ Proficient in using TensorFlow for model development",
        "⚡ Strong programming skills in Python for AI and machine learning tasks",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
  ],
};

// Education Page

const degrees = {
  degrees: [
    {
      title: "Herzing College Montreal",
      subtitle: "Post-Graduation Diploma in Programmer Analyst",
      logo_path: "herzing_logo.png",
      alt_name: "IIITDM Kurnool",
      duration: "2019 - 2020",
      descriptions: [
        "⚡ Completed Post-Graduation Diploma in Programmer Analyst from Herzing College, Montreal.",
        "⚡ Developed expertise in writing, modifying, integrating, and testing code for various applications.",
        "⚡ Acquired knowledge and skills in popular programming languages, including Microsoft VB.Net, Java, and PHP.",
        "⚡ Specialized in database design and development using SQL Server, and Internet programming with JavaScript.",
        "⚡ Explored areas like Image Processing, Cloud Computing, and Full Stack Development.",
      ],
      website_link: "https://www.herzing.ca/montreal/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Intro to ML: Image Processing",
      subtitle: "- Qwiklabs",
      logo_path: "google_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/50618d8f-39b5-4920-bf1c-6c00a85e5326",
      alt_name: "Google",
      color_code: "#1F70C199",
    },
    {
      title: "Kubernetes in Google Cloud",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/50618d8f-39b5-4920-bf1c-6c00a85e5326",
      alt_name: "Google",
      color_code: "#4285F499",
    },
    {
      title: "Action on Google Onward to Global Domination",
      subtitle: "- Google Assistant",
      logo_path: "googleAssistant.svg",
      certificate_link:
        "https://assistant.google.com/services/a/uid/00000051536af973?hl=en-US",
      alt_name: "Google",
      color_code: "#D83B0199",
    },
    {
      title: "Action on Google",
      subtitle: "- Google Assistant",
      logo_path: "googleAssistant.svg",
      certificate_link:
        "https://assistant.google.com/services/a/uid/00000051536af973?hl=en-US",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "National Cyber Olympiad",
      subtitle: "- Science Olympiad Foundation",
      logo_path: "nso.jpg",
      certificate_link:
        "https://drive.google.com/file/d/17T7YFLkaQ2leC78-YaIO_dCDVRsKzPVY/view?usp=sharing",
      alt_name: "SOF",
      color_code: "#1F70C199",
    },
    {
      title: "Microsoft AI Skilled Challenge",
      subtitle: "- Microsoft Azure",
      logo_path: "microsoft_azure.png",
      certificate_link:
        "https://learn.microsoft.com/en-us/users/tapandabhi-7248/challenges?tab=credentials-tab",
      alt_name: "Microsoft",
      color_code: "#8C151599",
    },
    {
      title: "Microsoft Cognitive Services Challenge",
      subtitle: "- Microsoft Azure",
      logo_path: "microsoft_azure.png",
      certificate_link:
        "https://learn.microsoft.com/en-us/users/tapandabhi-7248/challenges?tab=credentials-tab",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Microsoft Machine Learning Challenge",
      subtitle: "- Microsoft Azure",
      logo_path: "microsoft_azure.png",
      certificate_link:
        "https://learn.microsoft.com/en-us/users/tapandabhi-7248/challenges?tab=credentials-tab",
      alt_name: "Microsoft",
      color_code: "#1F70C199",
    },
    {
      title: "Microsoft Machine Learning Operations (MLOps) Challenge",
      subtitle: "- Microsoft Azure",
      logo_path: "microsoft_azure.png",
      certificate_link:
        "https://learn.microsoft.com/en-us/users/tapandabhi-7248/challenges?tab=credentials-tab",
      alt_name: "Microsoft",
      color_code: "#FFBB0099",
    },
    // {
    // 	title: "Machine Learning",
    // 	subtitle: "- Andrew Ng",
    // 	logo_path: "stanford_logo.png",
    // 	certificate_link:
    // 		"https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
    // 	alt_name: "Stanford University",
    // 	color_code: "#8C151599"
    // },
    // {
    // 	title: "Big Data",
    // 	subtitle: "- Kim Akers",
    // 	logo_path: "microsoft_logo.png",
    // 	certificate_link:
    // 		"https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
    // 	alt_name: "Microsoft",
    // 	color_code: "#D83B0199"
    // },
    // {
    // 	title: "Advanced Data Science",
    // 	subtitle: "- Romeo Kienzler",
    // 	logo_path: "ibm_logo.png",
    // 	certificate_link:
    // 		"https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    // 	alt_name: "IBM",
    // 	color_code: "#1F70C199"
    // },
    // {
    // 	title: "DL on Tensorflow",
    // 	subtitle: "- Laurence Moroney",
    // 	logo_path: "deeplearning_ai_logo.png",
    // 	certificate_link:
    // 		"https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
    // 	alt_name: "deeplearning.ai",
    // 	color_code: "#00000099"
    // },
    // {
    // 	title: "Fullstack Development",
    // 	subtitle: "- Jogesh Muppala",
    // 	logo_path: "coursera_logo.png",
    // 	certificate_link:
    // 		"https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    // 	alt_name: "Coursera",
    // 	color_code: "#2A73CC"
    // },
    // {
    // 	title: "Kuberenetes on GCP",
    // 	subtitle: "- Qwiklabs",
    // 	logo_path: "gcp_logo.png",
    // 	certificate_link:
    // 		"https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    // 	alt_name: "GCP",
    // 	color_code: "#4285F499"
    // },
    // {
    // 	title: "Cryptography",
    // 	subtitle: "- Saurabh Mukhopadhyay",
    // 	logo_path: "nptel_logo.png",
    // 	certificate_link:
    // 		"https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
    // 	alt_name: "NPTEL",
    // 	color_code: "#FFBB0099"
    // },
    // {
    // 	title: "Cloud Architecture",
    // 	subtitle: "- Qwiklabs",
    // 	logo_path: "gcp_logo.png",
    // 	certificate_link:
    // 		"https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    // 	alt_name: "GCP",
    // 	color_code: "#4285F499"
    // }
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I am currently working with Clickatell as a Software Developer, focusing on Web Apps using React and Angular in Toronto.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Developer",
          company: "Clickatell",
          company_url: "https://www.clickatell.com/",
          logo_path: "clickatell_logo.svg",
          duration: "Jul 2021 - PRESENT",
          location: "Toronto, Canada",
          description: [
            "⚡ Led the release management for all products, ensuring seamless deployment.",
            "⚡ Spearheaded the establishment of a uniform design system, enhancing speed and efficiency.",
            "⚡ Pioneered Micro-Frontend Architecture, boosting application performance, scalability, and maintainability.",
            "🚀 Projects:",
            "🔧 ChatDesk (React, Typescript, WebSockets, Redux, Jest, GIT):",
            "  - Implemented real-time data handling with WebSockets and Redux for ChatDesk.",
            "  - Introduced feature flagging, enhancing product flexibility with complete Unleash integration.",
            "  - Led migration from XMPP to WebSockets for improved performance.",
            "  - Integrated ChatDesk with Chat2Pay and Chathub, enriching the product ecosystem.",
            "  - Implemented AI-driven suggested responses.",
            "🔧 Bots4All (Angular, Typescript, Webpack, Karma):",
            "  - Led front-end development, established project architecture, and implemented a design system.",
            "🔧 Unity (Angular, Typescript, Webpack, Karma):",
            "  - Contributed to Unity, a portal consolidating various Clickatell product offerings.",
            "  - Developed a product dashboard for managing different products and roles.",
            "🔧 Chathub (Angular, Typescript, Webpack, Karma):",
            "  - Contributed to Chathub, enabling clients to integrate third-party apps with Clickatell products.",
            "🔧 Unified Account Portal (UAP) (Angular, Typescript, Karma):",
            "  - Developed the Unified Account Portal (UAP) for unified admin account search functionality.",
          ],

          color: "#0879bf",
        },
        {
          title: "Full-Stack Developer",
          company: "TimeB",
          company_url: "https://www.timeb.ca/",
          logo_path: "timeb_logo.svg",
          duration: "Mar 2020 - Jul 2021",
          location: "Montreal, Canada",
          description: [
            "⚡ Developed a cross-platform application using React Native with a Laravel backend, managed TimeB website development in React, conducted unit testing with Jest, and handled seamless deployment to the Play Store and App Store while setting up Firebase and AWS for project integration.",
            "⚡ Implemented authentication, calendar, events, notifications, real-time chat functionality, sharable notes, and split bills features, collectively enhancing the application's overall functionality and collaborative aspects.",
            "⚡ Led a team of five and managed project lifecycle from start to finish.",
          ],
          color: "#0879bf",
        },
        {
          title: "Full-Stack Developer",
          company: "Brossard App Design",
          company_url: "https://brossarddesign.com/",
          logo_path: "brossard_logo.ico",
          duration: "Jan 2020 - Dec 2020",
          location: "Montreal, Canada",
          description: [
            "⚡ Developed cross-platform mobile applications using React Native and applied full-stack expertise by working on web applications with React, Angular, Node.js, Laravel, and Spring Boot.",
            "⚡ Demonstrated adaptability by seamlessly transitioning between technologies and engaging in complex problem-solving scenarios to ensure optimal application functionality.",
          ],
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Full-Stack Developer",
          company: "Brossard App Design",
          company_url: "https://www.delhivery.com/",
          logo_path: "brossard_logo.ico",
          duration: "Mar 2020 - Jun 2020",
          location: "Montreal, Canada",
          description: [
            "⚡ Interned as a Full Stack Developer at Brossard App Design, Montreal.",
            "⚡ Focused on Mobile, Web Apps, and Backend development.",
            "⚡ Gained hands-on experience in agile development methodologies.",
            "🚀 Key contributions:",
            "🔧 Assisted in the development and maintenance of web and mobile applications.",
            "🔧 Collaborated with senior developers to troubleshoot and resolve technical issues.",
            "🔧 Participated in daily stand-up meetings and sprint planning sessions.",
          ],
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Remote",
          description: [
            "⚡ Actively contributing to various open-source projects on GitHub.",
            "⚡ Providing bug fixes, implementing feature requests, and creating documentation.",
            "⚡ Collaborating with a global community of developers.",
            "🚀 Key contributions:",
            "🔧 Submitted pull requests for bug fixes and new features to multiple open-source projects.",
            "🔧 Engaged in discussions and provided support to other developers in the community.",
            "🔧 Demonstrated strong problem-solving and communication skills.",
          ],
          color: "#181717",
        },
        {
          title: "Hacktoberfest 2018-2023",
          company: "Digital Ocean",
          company_url: "https://www.digitalocean.com/",
          logo_path: "digitalOcean_logo.png",
          duration: "Oct 2018 - Oct 2023",
          location: "Remote",
          description: [
            "🚀 Participated in Hacktoberfest, DigitalOcean’s annual event dedicated to supporting open-source projects throughout October.",
            "🌐 Contributed to various open-source projects, including those powering modern tech infrastructure and DigitalOcean's own products.",
            "🤝 Collaborated with passionate individuals to enhance and maintain essential open-source projects that may lack sufficient resources.",
            "💡 Sharpened skills, learned new technologies, and celebrated the spirit of open source by giving back to the community.",
          ],
          color: "#000000",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "tapan_profile.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with React, React-Native, Angular, Android, Web Development.",
  },
  addressSection: {
    title: "Address",
    subtitle: "Toronto, Ontario, Canada",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/Mzj82yfV6C1KPRQB9",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 5147733607",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  //competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
